/* sp-gallery-mix.js — galería "grilla mixta" de la ficha (brief product.layout.galleryStyle "grid-mix", setting
   sp_gallery_style de main-product, PAR-134; dueño B3a). Lo carga snippets/product-images.liquid (defer) sólo con la grilla
   mixta. El layout lo hace el CSS (assets/sp-gallery-mix.css) desde el primer pintado y theme.js mueve la tira del celular
   (P7f/P7g) y marca el set de imágenes de la variante (P7k, P7m); acá sólo:
   (1) Carrusel del celular: las flechas mueven la tira con su scroll nativo (scroll-snap) y el contador "n / N" sigue a la
       foto elegida (.is-selected, P7g) con un MutationObserver: sin listeners de scroll ni de gestos.
   (2) Visor al tocar una foto (desktop y celular): el PhotoSwipe del tema (vendor-scripts) con el aspecto de la tienda de
       referencia (mainClass sp-pv): fondo oscuro al 60 %, la foto como tarjeta blanca con 22 px de radio, aparece y se va con
       un fundido de 160 ms (sin animar con prefers-reduced-motion), sin la barra del tema. La X blanca sigue a la esquina de
       arriba a la derecha de la foto, flechas blancas a los costados sólo con mouse en pantallas anchas y la píldora "n / N"
       abajo. Un click o un doble toque acerca 2,5× del ajuste (y vuelve), el pellizco llega hasta 6×; tocar afuera de la
       foto, Esc o la X cierran. Cada foto pide el ancho justo de la serie 750/1100/1500/1946 (data-sp-pv: la de 1946 px) para
       el tamaño en pantalla y la densidad, y la de 1946 recién al acercar; sólo se precargan la anterior y la siguiente
       (preload [1, 1]). Mientras carga se ve la foto de la galería ya cargada (currentSrc) o una tarjeta blanca.
       Diálogo con aria-modal, el foco adentro (Tab recorre sus botones) y de vuelta a la foto al cerrar; la página no se
       mueve (overflow hidden y, en pantallas táctiles, el body fijo en su lugar como el visor de reseñas: iOS ignora el
       overflow) y el ancho de la barra de desplazamiento pasa a padding-right (CLS 0). Al cerrar, la tira del celular queda
       en la foto que se estaba viendo.
   Idempotente (flag global), delegación en document y shopify:section:load para el editor de temas. Sin listeners táctiles
   ni de rueda propios: los gestos del visor son los de PhotoSwipe. */
(function () {
  'use strict';
  if (window.__spGalleryMixInit) return;
  window.__spGalleryMixInit = true;

  var SLIDER = '.product-slideshow[data-sp-mix]';
  var SLIDE = '.product-main-slide';
  var WIDTHS = [750, 1100, 1500, 1946];
  var ZOOM = 2.5;
  var MAX_ZOOM = 6;

  function toArray(list) { return Array.prototype.slice.call(list || []); }
  function still() { return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); }
  function visibleSlides(slider) {
    return toArray(slider.querySelectorAll(SLIDE)).filter(function (s) { return !s.classList.contains('sp-set-off'); });
  }

  // ---------------------------------------------------------------- (1) carrusel del celular: flechas y contador

  function initNav(root) {
    var slider = root.querySelector(SLIDER);
    var nav = root.querySelector('[data-sp-mix-nav]');
    if (!slider || !nav || nav.__spMix) return;
    nav.__spMix = true;
    var cur = nav.querySelector('[data-sp-mix-cur]');
    var total = nav.querySelector('[data-sp-mix-total]');
    var prev = nav.querySelector('[data-sp-mix-prev]');
    var next = nav.querySelector('[data-sp-mix-next]');
    var pending = false;

    function selected(list) {
      for (var i = 0; i < list.length; i++) if (list[i].classList.contains('is-selected')) return i;
      return -1;
    }
    function update() {
      pending = false;
      var list = visibleSlides(slider);
      var i = selected(list);
      // sin tira (desktop) no hay foto elegida: el contador queda en la destacada
      if (i < 0) i = Math.max(0, list.indexOf(slider.querySelector('.starting-slide')));
      if (cur) cur.textContent = String(i + 1);
      if (total) total.textContent = String(list.length);
      // la flecha del extremo se apaga; si tenía el foco, pasa a la otra (no cae al body)
      var had = document.activeElement;
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= list.length - 1;
      if (had && had.disabled && (had === prev || had === next)) {
        var other = had === prev ? next : prev;
        if (other && !other.disabled) other.focus({ preventScroll: true });
      }
      nav.hidden = list.length < 2;
    }
    function schedule() {
      if (pending) return;
      pending = true;
      requestAnimationFrame(update);
    }
    function go(step) {
      var list = visibleSlides(slider);
      var i = selected(list);
      if (i < 0) i = 0;
      var target = list[i + step];
      if (!target || !slider.clientWidth) return;
      slider.scrollTo({ left: target.offsetLeft - (slider.clientWidth - target.offsetWidth) / 2, behavior: still() ? 'auto' : 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    if (window.MutationObserver) {
      // la foto elegida (.is-selected de P7g), el set de la variante (.sp-set-off de P7k) y el orden (P7l)
      new MutationObserver(schedule).observe(slider, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });
    }
    update();
  }

  // ---------------------------------------------------------------- (2) visor

  var state = null;

  function svg(d) {
    return '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="' + d + '"/></svg>';
  }
  function button(cls, label, d) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'sp-pv__btn ' + cls;
    b.setAttribute('aria-label', label);
    b.innerHTML = svg(d);
    return b;
  }
  /** La URL de la foto con otro ancho (image_url: width de Shopify; sin ese parámetro, la misma). */
  function sized(base, w) {
    if (!base) return '';
    return /([?&])width=\d+/.test(base) ? base.replace(/([?&])width=\d+/, '$1width=' + w) : base;
  }
  function isTouch() {
    return /iPhone|iPad|iPod/.test(navigator.userAgent) || (navigator.maxTouchPoints > 1 && /Mac/.test(navigator.platform || '')) ||
      !!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches);
  }
  /** Márgenes del visor (los de la referencia): celular 72 arriba y abajo, 16 a los costados; desktop 56/64 y 100. */
  function pads() {
    var wide = !!(window.matchMedia && window.matchMedia('(min-width: 768px)').matches);
    return wide ? { top: 56, bottom: 64, side: 100 } : { top: 72, bottom: 72, side: 16 };
  }

  function lockScroll(on) {
    var de = document.documentElement;
    var b = document.body;
    if (on) {
      state.lockY = window.pageYOffset || de.scrollTop || 0;
      var bar = window.innerWidth - de.clientWidth;
      de.classList.add('sp-pv-lock');
      if (bar > 0) de.style.paddingRight = bar + 'px';
      if (isTouch()) {
        state.fixed = true;
        b.style.position = 'fixed';
        b.style.top = -state.lockY + 'px';
        b.style.left = '0';
        b.style.right = '0';
      }
      return;
    }
    de.classList.remove('sp-pv-lock');
    de.style.paddingRight = '';
    if (state.fixed) {
      b.style.position = '';
      b.style.top = '';
      b.style.left = '';
      b.style.right = '';
      var sb = de.style.scrollBehavior;
      de.style.scrollBehavior = 'auto';
      window.scrollTo(0, state.lockY);
      de.style.scrollBehavior = sb;
    }
  }

  function open(root, slide) {
    if (state) return;
    var PS = window.PhotoSwipe;
    var UI = window.PhotoSwipeUI_Default;
    var el = document.querySelector('.pswp');
    var slider = root.querySelector(SLIDER);
    if (!PS || !UI || !el || !slider) return;
    var slides = visibleSlides(slider).filter(function (s) { return !!s.querySelector('img.photoswipe__image'); });
    var index = slides.indexOf(slide);
    if (index < 0) return;
    var pad = pads();
    var dpr = Math.min(window.devicePixelRatio || 1, 3);
    var items = slides.map(function (s) {
      var img = s.querySelector('img.photoswipe__image');
      var w = parseInt(img.getAttribute('data-photoswipe-width'), 10) || img.naturalWidth || 1000;
      var h = parseInt(img.getAttribute('data-photoswipe-height'), 10) || img.naturalHeight || 1000;
      var loaded = img.complete && img.naturalWidth > 0 && img.currentSrc;
      return { w: w, h: h, base: img.getAttribute('data-sp-pv') || img.getAttribute('data-photoswipe-src'), msrc: loaded ? img.currentSrc : '', src: '', slide: s };
    });
    var reduced = still();
    var label = function (k) { return root.getAttribute('data-sp-label-' + k) || ''; };

    state = { g: null, el: el, root: root, slider: slider, items: items, index: index, opener: document.activeElement, prevGallery: el.__omGallery, ui: [] };

    var g = new PS(el, UI, items, {
      index: index,
      mainClass: 'sp-pv',
      bgOpacity: 0.6,
      showHideOpacity: true,
      showAnimationDuration: reduced ? 0 : 160,
      hideAnimationDuration: reduced ? 0 : 160,
      history: false,
      focus: false, // el foco lo pone el visor en la X (con true PhotoSwipe enfoca el diálogo después)
      escKey: true,
      arrowKeys: true,
      loop: items.length > 2,
      preload: [1, 1],
      closeOnScroll: false,
      pinchToClose: false,
      allowPanToNext: false,
      tapToClose: false,
      tapToToggleControls: false,
      clickToCloseNonZoomable: false,
      captionEl: false, fullscreenEl: false, zoomEl: false, shareEl: false, counterEl: false, arrowEl: false, preloaderEl: false, closeEl: false,
      // los márgenes de arriba y abajo los toma PhotoSwipe (vGap); los de los costados, el CSS del visor (scroll-wrap)
      barsSize: { top: pad.top, bottom: pad.bottom },
      fitControlsWidth: 0,
      maxSpreadZoom: MAX_ZOOM,
      isClickableElement: function (t) { return t.tagName === 'A' || t.tagName === 'BUTTON'; },
      getDoubleTapZoom: function (isMouse, item) { return item.initialZoomLevel * ZOOM; },
    });
    state.g = g;

    // el ancho justo para el tamaño en pantalla y la densidad (sin agrandar más allá del original)
    g.listen('gettingData', function (i, item) {
      if (item.src) return;
      var availW = Math.max(1, window.innerWidth - 2 * pad.side);
      var availH = Math.max(1, window.innerHeight - pad.top - pad.bottom);
      var need = Math.min(item.w, availW, (availH * item.w) / item.h) * dpr;
      var w = WIDTHS[WIDTHS.length - 1];
      for (var k = 0; k < WIDTHS.length; k++) if (WIDTHS[k] >= need) { w = WIDTHS[k]; break; }
      item.src = sized(item.base, w);
      item.big = w === WIDTHS[WIDTHS.length - 1];
    });

    // al acercar, la de 1946 px (se cambia cuando ya bajó: la foto no parpadea)
    function upgrade() {
      var it = g.currItem;
      if (!it || it.big) return;
      it.big = true;
      var big = sized(it.base, WIDTHS[WIDTHS.length - 1]);
      var pre = new Image();
      pre.onload = function () {
        if (!state || state.g !== g) return;
        it.src = big;
        var img = it.container && it.container.querySelector('img.pswp__img:not(.pswp__img--placeholder)');
        if (img) img.src = big;
      };
      pre.src = big;
    }
    function tune() {
      var it = g.currItem;
      if (it && it.initialZoomLevel) g.options.maxSpreadZoom = Math.max(1, it.initialZoomLevel * MAX_ZOOM);
    }

    // click (mouse): ajuste ↔ 2,5× en el punto del click
    g.toggleDesktopZoom = function (point) {
      var it = g.currItem;
      var fit = it.initialZoomLevel;
      var zoomed = g.getZoomLevel() > fit * 1.01;
      g.mouseZoomedIn = !zoomed;
      el.classList.toggle('pswp--zoomed-in', g.mouseZoomedIn);
      g.zoomTo(zoomed ? fit : fit * ZOOM, point || { x: window.innerWidth / 2, y: window.innerHeight / 2 }, reduced ? 0 : 333);
      if (!zoomed) upgrade();
    };
    g.listen('doubleTap', function () { setTimeout(function () { if (state && state.g === g && g.getZoomLevel() > g.currItem.initialZoomLevel * 1.01) upgrade(); }, 360); });
    g.listen('zoomGestureEnded', function () { if (g.getZoomLevel() > g.currItem.initialZoomLevel * 1.01) upgrade(); });

    // botones propios (fuera del área de gestos de PhotoSwipe)
    var close = button('sp-pv__close', label('close'), 'M6 6l12 12M18 6L6 18');
    var prev = button('sp-pv__arrow sp-pv__arrow--prev', label('prev'), 'M15 5l-7 7 7 7');
    var next = button('sp-pv__arrow sp-pv__arrow--next', label('next'), 'M9 5l7 7-7 7');
    var count = document.createElement('div');
    count.className = 'sp-pv__count';
    count.setAttribute('aria-live', 'polite');
    close.addEventListener('click', function () { g.close(); });
    prev.addEventListener('click', function () { g.prev(); });
    next.addEventListener('click', function () { g.next(); });
    state.ui = items.length > 1 ? [close, prev, next, count] : [close];
    state.ui.forEach(function (n) { el.appendChild(n); });

    // la X en la esquina de arriba a la derecha de la foto (ajustada), adentro de la pantalla
    function place() {
      var it = g.currItem;
      if (!it || !it.initialPosition || !g.scrollWrap) return;
      var r = g.scrollWrap.getBoundingClientRect();
      var size = close.offsetWidth || 40;
      var right = r.left + it.initialPosition.x + it.w * it.initialZoomLevel;
      var top = r.top + it.initialPosition.y;
      var x = Math.min(window.innerWidth - size - 8, Math.max(8, right - size));
      var y = Math.max(8, top - size - 8);
      close.style.transform = 'translate(' + Math.round(x) + 'px, ' + Math.round(y) + 'px)';
    }
    function sync() {
      state.index = g.getCurrentIndex();
      count.textContent = (state.index + 1) + ' / ' + items.length;
      tune();
      place();
    }

    // tocar afuera de la foto cierra (con el dedo; con mouse lo hace la UI); click en un margen, también
    function onTap(e) {
      var d = e.detail || {};
      var t = e.target;
      var isImg = t && t.classList && t.classList.contains('pswp__img');
      if (d.pointerType === 'mouse') {
        // foto chica que ya se ve a su tamaño: la UI no acerca (P3c no corre en este visor si el tema nunca abrió el suyo)
        if (isImg && !el.__omDeadTapFix && g.getZoomLevel() === 1 && g.getZoomLevel() <= g.currItem.fitRatio) g.toggleDesktopZoom(d.releasePoint);
        return;
      }
      if (!isImg && t && /pswp__(item|zoom-wrap|container|scroll-wrap|bg)/.test(String(t.className))) g.close();
    }
    function onClick(e) {
      if (e.target === el || (e.target.classList && e.target.classList.contains('pswp__bg'))) g.close();
    }
    // Tab sólo por los botones del visor
    function onKey(e) {
      if (e.key !== 'Tab') return;
      var list = state.ui.filter(function (n) { return n.tagName === 'BUTTON' && n.getClientRects().length; });
      if (!list.length) return;
      var i = list.indexOf(document.activeElement);
      e.preventDefault();
      list[(i + (e.shiftKey ? list.length - 1 : 1) + (i < 0 && e.shiftKey ? 1 : 0)) % list.length].focus();
    }
    el.addEventListener('pswpTap', onTap);
    el.addEventListener('click', onClick);
    document.addEventListener('keydown', onKey, true);
    el.__omGallery = g;
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', root.getAttribute('data-sp-label') || '');

    g.listen('afterChange', sync);
    g.listen('resize', function () { tune(); place(); });
    // el foco en la X (PhotoSwipe enfoca el diálogo al abrir)
    g.listen('initialZoomInEnd', function () { place(); if (state && state.g === g) close.focus({ preventScroll: true }); });
    g.listen('close', function () { state.index = g.getCurrentIndex(); });
    g.listen('destroy', function () {
      el.removeEventListener('pswpTap', onTap);
      el.removeEventListener('click', onClick);
      document.removeEventListener('keydown', onKey, true);
      state.ui.forEach(function (n) { if (n.parentNode) n.parentNode.removeChild(n); });
      el.__omGallery = state.prevGallery;
      el.removeAttribute('aria-modal');
      el.removeAttribute('aria-label');
      el.classList.remove('pswp--zoomed-in');
      lockScroll(false);
      // la tira del celular queda en la foto que se veía (sin animar: pasa detrás del visor)
      var s = state.items[state.index] && state.items[state.index].slide;
      var strip = state.slider;
      if (s && strip.scrollWidth > strip.clientWidth + 1) strip.scrollTo({ left: s.offsetLeft - (strip.clientWidth - s.offsetWidth) / 2, behavior: 'auto' });
      // el foco a la foto vista: la de la tira (con tabindex), su lupa si se ve (desktop) o lo que lo tenía al abrir
      var shown = function (n) { return n && n.isConnected && n.getClientRects().length > 0 && typeof n.focus === 'function'; };
      var zoomBtn = s && s.querySelector('.js-photoswipe__zoom');
      var back = s && s.hasAttribute('tabindex') && shown(s) ? s : shown(zoomBtn) ? zoomBtn : state.opener;
      state = null;
      if (shown(back)) back.focus({ preventScroll: true });
    });

    lockScroll(true);
    g.init();
    sync();
    close.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    var slide = t && t.closest && t.closest(SLIDER + ' ' + SLIDE);
    if (!slide || state) return;
    var root = slide.closest('[data-sp-mix-root]');
    if (!root || root.getAttribute('data-sp-viewer') !== 'true') return;
    // la foto o su lupa (sólo para el teclado); un video o un modelo 3D tienen sus propios controles
    if (!t.closest('img.photoswipe__image, .js-photoswipe__zoom')) return;
    e.preventDefault();
    open(root, slide);
  });
  // la foto elegida de la tira (con foco, P7g) se abre con Enter o espacio
  document.addEventListener('keydown', function (e) {
    if (state || (e.key !== 'Enter' && e.key !== ' ')) return;
    var slide = e.target && e.target.matches && e.target.matches(SLIDER + ' ' + SLIDE) ? e.target : null;
    var root = slide && slide.closest('[data-sp-mix-root]');
    if (!root || root.getAttribute('data-sp-viewer') !== 'true' || !slide.querySelector('img.photoswipe__image')) return;
    e.preventDefault();
    open(root, slide);
  });

  // ---------------------------------------------------------------- inicio y editor de temas

  function init(scope) {
    toArray((scope || document).querySelectorAll('[data-sp-mix-root]')).forEach(initNav);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function () { if (state && state.g) state.g.close(); });
})();
